import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  constructor(private toastr: ToastrService, public updates: SwUpdate, private appRef: ApplicationRef) { }

  public CheckForUpdates(performUpdate: boolean) {
    const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable === true));

    this.updates.versionUpdates.subscribe((evt) => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          console.log(`Downloading new app version: ${evt.version.hash}`);
          break;
        case 'VERSION_READY':
          console.log(`Current app version: ${evt.currentVersion.hash}`);
          console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
          break;
        case 'VERSION_INSTALLATION_FAILED':
          console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
          break;
      }
    });

    appIsStable$.subscribe(() => {
      console.log('App stable, checking for update...');
       
          
      const updateFound = this.updates.checkForUpdate();
      updateFound.then((update: any) =>{
        if (update && performUpdate) {
          this.toastr.success('New version found, reloading...');
          document.location.reload();
        } else if (update && !performUpdate) {
          this.toastr.success('A new version is available! Get the latest update from the Profile page.', 'Update available', {disableTimeOut: true});
        } else {
          console.log('Application up-to-date');
          if (performUpdate) this.toastr.success('You\'re on the latest version!');
        }
      }).catch(_ => {
        if (performUpdate) this.toastr.error('Cannot check for updates at this time. Check connection'); 
        console.log('%c Cannot check for updates. running in localhost or service workers are disabled or not supported', 
                                    'color: antiquewhite; font-weight: bold; background-color: black;');  });   
    }, err => { console.log("Error in waiting for stabilization"); console.log(err); });
  }
}
